import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() title;
  @Input() currentComponent;
  @Output() close = new EventEmitter;


  constructor() {
  }

  ngOnInit() {
  }

  goToBegin() {
    if ( this.title === 'Pick a Day' ) {
      let loc = window.location.href.split('?')[0];
      window.location.replace(loc);
    }
  }
}




// WEBPACK FOOTER //
// /app/src/app/Components/header/header.component.ts